import { Reference, useMutation } from "@apollo/client";
import { updateMutationsMap } from "../api/mutations";
import { EntityString } from "../types";

export function useUpdateEntityMutation(entity: EntityString) {
  const mutation = updateMutationsMap[entity];
  
  return useMutation(mutation);
}
